<template>      
    <NuxtImg      
      v-if="mediaData.image.url"
      :src="toImgixPath(mediaData.image.url)"
      loading="lazy"
      provider="imgix"
      format="webp"
      fit="crop"
      width="698"
      height="698"
      :alt="alt"
      class="w-full"
      :sizes="sizes"
      :modifiers="{ 
        ar: '1:1',
        auto: 'format,compress',        
        'fp-x': mediaData.presentation ? mediaData.presentation.asJson.focalPoint.x : 0.5,
        'fp-y': mediaData.presentation ? mediaData.presentation.asJson.focalPoint.y : 0.5,
      }"/>
    
</template>

<script setup>
    import { useImageUtils } from '@/composables/useImageUtils';
    const {toImgixPath} = useImageUtils();

    const props = defineProps({
      mediaData: {
        type: Object,
        required: true
      },
      alt: {
        type: String,
        required: true
      },
      width: {
        type: [String, Number],
        default: 349
      },
      height: {
        type: [String, Number],
        default: 349
      },
      sizes: {
        type: String,
        default: '127px sm:127px md:200px lg:371px'
      }
    });

</script>

<style scoped>

</style>